
import React, { lazy } from "react";
import Settings from "../Screens/Settings";

//Dashboard
const dashboard = lazy(() => import('src/Screens/Coach/Dashboard'));

//Calendar
const calendar = lazy(() => import('src/Screens/Coach/Calendar'));
const calendarSettings = lazy(() => import('src/Screens/Coach/Calendar/settings'));

//Mensajes
const messagesList = lazy(() => import('src/Screens/Coach/Messages/list'));

//Sessions
const sessionsNew = lazy(() => import('src/Screens/Coach/Calendar/sessions/new'));
const sessionsEdit = lazy(() => import('src/Screens/Coach/Calendar/sessions/edit'));
const sessionsFinished = lazy(() => import('src/Screens/Coach/Sessions/finished'));
const sessionsConfirm = lazy(() => import('src/Screens/Coach/Sessions/confirm'));

//Clients
const clientsList = lazy(() => import('src/Screens/Coach/Clients/list'));
const clientsNew = lazy(() => import('src/Screens/Coach/Clients/new'));
const clientsEdit = lazy(() => import('src/Screens/Coach/Clients/edit'));
const clientsView = lazy(() => import('src/Screens/Coach/Clients/view'));

//Groups
const groupsList = lazy(() => import('src/Screens/Coach/Groups/list'));
const groupsNew = lazy(() => import('src/Screens/Coach/Groups/new'));
const groupsEdit = lazy(() => import('src/Screens/Coach/Groups/edit'));
const groupsView = lazy(() => import('src/Screens/Coach/Groups/view'));

//Profile
const profile = lazy(() => import('src/Screens/Coach/Profile'));
const profileInfo = lazy(() => import('src/Screens/Coach/Profile/info'));
const profileContact = lazy(() => import('src/Screens/Coach/Profile/contact'));
const profileAbout = lazy(() => import('src/Screens/Coach/Profile/about'));
const profileAccount = lazy(() => import('src/Screens/Coach/Profile/account'));
const profileNotifications = lazy(() => import('src/Screens/Coach/Profile/notifications'));
const profileCustomization = lazy(() => import('src/Screens/Coach/Profile/customization'));
const profilePayment= lazy(() => import('src/Screens/Coach/Profile/payment'));

//Memoramdums
const memoramdumsList = lazy(() => import('src/Screens/Coach/Memorandums/list'));
const memoramdumsNew = lazy(() => import('src/Screens/Coach/Memorandums/new'));
const memoramdumsEdit = lazy(() => import('src/Screens/Coach/Memorandums/edit'));

//Shared
const viewGoals = lazy(() => import('src/Screens/Shared/Goals'));
const viewActions = lazy(() => import('src/Screens/Shared/Actions'));
const viewSessions = lazy(() => import('src/Screens/Shared/Sessions'));
const viewResources = lazy(() => import('src/Screens/Shared/Resources'));
const viewNotes = lazy(() => import('src/Screens/Shared/Notes'));

//Resources
const resourcesList = lazy(() => import('src/Screens/Coach/Resources/list'));
const resourcesNew = lazy(() => import('src/Screens/Coach/Resources/new'));
const resourcesEdit = lazy(() => import('src/Screens/Coach/Resources/edit'));
const resourcesView = lazy(() => import('src/Screens/Coach/Resources/view'));

//Resources
const notificationsList = lazy(() => import('src/Screens/Shared/Notifications'));
const resourcesDeteail = lazy(() => import('src/Screens/Resources/detail'));
//Notifications
const Notifications = lazy(() => import('src/Screens/Shared/Notifications'));

//Ending
const endingView= lazy(() => import('src/Screens/Shared/Ending'));

//Guides
const guides = lazy(() => import('src/Screens/Guides'));

const routesCoach = [
    {
        path: "/dashboard",
        element: dashboard,
        isPrivate: true,
        exact: true
    },
    {
        path: "/profile",
        element: profile,
        isPrivate: true,
        exact: true
    },
    {
        path: "/profile/info",
        element: profileInfo,
        isPrivate: true,
        exact: true
    },
    {
        path: "/profile/contact",
        element: profileContact,
        isPrivate: true,
        exact: true
    },
    {
        path: "/profile/about",
        element: profileAbout,
        isPrivate: true,
        exact: true
    },
    {
        path: "/profile/account",
        element: profileAccount,
        isPrivate: true,
        exact: true
    },
    {
        path: "/profile/notifications",
        element: profileNotifications,
        isPrivate: true,
        exact: true
    },
    {
        path: "/profile/customization",
        element: profileCustomization,
        isPrivate: true,
        exact: true
    },
    {
        path: "/profile/payment",
        element: profilePayment,
        isPrivate: true,
        exact: true
    },
    {
        path: "/settings",
        element: Settings,
        isPrivate: true,
        exact: true
    },
    {
        path: "/notifications",
        element: Notifications,
        isPrivate: true,
        exact: true
    },
    {
        path: "/clients",
        element: clientsList,
        isPrivate: true,
        exact: true
    },
    {
        path: "/clients/new",
        element: clientsNew,
        isPrivate: true,
        exact: true
    },
    {
        path: "/clients/edit/:idClient",
        element: clientsEdit,
        isPrivate: true,
        exact: true
    },
    {
        path: "/clients/view/:idClient",
        element: clientsView,
        isPrivate: true,
        exact: true
    },
    {
        path: "/groups",
        element: groupsList,
        isPrivate: true,
        exact: true
    },
    {
        path: "/groups/new",
        element: groupsNew,
        isPrivate: true,
        exact: true
    },
    {
        path: "/groups/view/:groupId",
        element: groupsView,
        isPrivate: true,
        exact: true
    },
    {
        path: "/groups/edit/:groupId",
        element: groupsEdit,
        isPrivate: true,
        exact: true
    },
    {
        path: "/calendar",
        element: calendar,
        isPrivate: true,
        exact: true
    },
    {
        path: "/calendar/settings",
        element: calendarSettings,
        isPrivate: true,
        exact: true
    },
    {
        path: "/calendar/session/new/:type",
        element: sessionsNew,
        isPrivate: true,
        exact: true
    },
    {
        path: "/calendar/session/edit/:type/:sessionId",
        element: sessionsEdit,
        isPrivate: true,
        exact: true
    },
    {
        path: "/messages",
        element: messagesList,
        isPrivate: true,
        exact: true
    },
    {
        path: "/messages/:type/:itemId",
        element: messagesList,
        isPrivate: true,
        exact: true
    },
    {
        path: "/resources",
        element: resourcesList,
        isPrivate: true,
        exact: true
    },
    {
        path: "/resources/:sessionId",
        element: resourcesList,
        isPrivate: true,
        exact: true
    },
    {
        path: "/resource/new/:type",
        element: resourcesNew,
        isPrivate: true,
        exact: true
    },
    {
        path: "/resource/edit/:resourceId",
        element: resourcesEdit,
        isPrivate: true,
        exact: true
    },
    {
        path: "/resource/view/:resourceId",
        element: resourcesView,
        isPrivate: true,
        exact: true
    },
    {
        path: "/memorandums",
        element: memoramdumsList,
        isPrivate: true,
        exact: true
    },
    {
        path: "/memorandums/new",
        element: memoramdumsNew,
        isPrivate: true,
        exact: true
    },
    {
        path: "/memorandums/edit/:memoramdumId",
        element: memoramdumsEdit,
        isPrivate: true,
        exact: true
    },
    {
        path: "/session/finished/:sessionId",
        element: sessionsFinished,
        isPrivate: true,
        exact: true
    },
    {
        path: "/session/confirm/:sessionId",
        element: sessionsConfirm,
        isPrivate: true,
        exact: true
    },
    {
        path: "/goals/:itemId/:type",
        element: viewGoals,
        isPrivate: true,
        exact: true
    },
    {
        path: "/actions/:itemId/:type",
        element: viewActions,
        isPrivate: true,
        exact: true
    },
    {
        path: "/sessions/:itemId/:type",
        element: viewSessions,
        isPrivate: true,
        exact: true
    },
    {
        path: "/resources/:itemId/:type",
        element: viewResources,
        isPrivate: true,
        exact: true
    },
    {
        path: "/notes/:itemId/:type",
        element: viewNotes,
        isPrivate: true,
        exact: true
    },
    {
        path: "/ending",
        element: endingView,
        isPrivate: true,
        exact: true
    },
    {
        path: "/ending/:sessionId",
        element: endingView,
        isPrivate: true,
        exact: true
    },
    {
        path: "/guides",
        element: guides,
        isPrivate: true,
        exact: true
    }
];

export default routesCoach;